<template>
    <div>
        <!-- HERE COMPONENT -->
        <Side-Menu
            panelName="Control Panel"
            logo="https://i0.wp.com/arcellatelecom.com/wp-content/uploads/2020/03/arcella-logo-footer.png?resize=700%2C124"
            ref="sidemenu"
            :menu="$store.state.panelItems"
        ></Side-Menu>
        <div class="columns">
            <div class="column w-220" :class="{ 'menu-small': isSmallMenu }"></div>
            <div class="column">
                <div class="navbar-osa">
                    <a class="nav-item-start mobile-btn" @click="$refs.sidemenu.mobileToggle = true">
                        <b-icon icon="backburger" />
                    </a>
                    <div class="nav-middle"></div>
                    <!-- <a class="nav-item">NAV Item</a> -->
                    <div class="nav-item notification-btn" v-if="$store.state.isNotifications">
                        <a @click="showNotifications = !showNotifications">
                            <b-icon pack="far" icon="bell" custom-class="h-effect" :class="{ glow: $store.getters.unreadNotifications }" />
                            <span title="Badge top right" class="badge">{{ $store.getters.unreadNotifications }}</span>
                        </a>
                        <!-- Notification Modal -->
                        <!-- <div class="notification-list"></div> -->
                        <div v-if="showNotifications">
                            <div class="notifications">
                                <h2>
                                    Notifications - <span>{{ $store.getters.unreadNotifications }}</span>
                                </h2>
                                <a
                                    class="notifications-item"
                                    v-for="(item, index) in $store.state.notifications"
                                    :key="index"
                                    @click="notificationAction(item)"
                                    :class="{ new: !item.is_read }"
                                >
                                    <b-icon pack="mdi" :icon="item.icon" />
                                    <div class="text">
                                        <h4>{{ item.title }}</h4>
                                        <p>{{ item.details }}</p>
                                    </div>
                                </a>
                            </div>
                            <div class="notifications-dismiss" @click="showNotifications = false" />
                        </div>
                    </div>
                    <div class="nav-item">
                        <b>{{ $store.state.profile.name }}</b>
                    </div>
                    <div class="divider" />
                    <router-link active-class="do-nothing" class="nav-item h-effect" to="/login?logout">Logout</router-link>
                </div>
                <div class="page-title">
                    <b-icon pack="mdi" :icon="selectedItem.icon" size="is-large" />
                    {{ selectedItem.name }}
                </div>
                <div class="page-content">
                    <router-view v-if="initialized"></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import SideMenu from "../components/SideMenu.vue";

export default {
    name: "Home",
    components: {
        SideMenu: SideMenu,
    },
    data() {
        return {
            selectedItem: {},
            isSmallMenu: false,
            showNotifications: false,
            intervalId: null,
            initialized: false,
        };
    },
    mounted() {
        this.init();
        this.$store.dispatch("loadNotifications", this.$axios);
        this.intervalId = setInterval(() => this.$store.dispatch("loadNotifications", this.$axios), 30 * 1000);

        if (this.$route.path === "/home") {
            this.$router.replace("/home/dashboard");
        }
        this.checkSelected(this.$route.path);
    },
    destroyed() {
        clearInterval(this.intervalId);
    },
    methods: {
        async init() {
            await this.$store.dispatch("loadAPI", this.$axios);
            this.initialized = true;
        },
        notificationAction(item) {
            // If new then mark as read
            if (!item.is_read) {
                this.$http
                    .post(`/notifications/${item.id}/read`, { id: item.id })
                    .then(() => (item.is_read = true))
                    .catch(() => this.notify("Error setting notification to read", "is-danger"));
            }
        },
        checkSelected(val) {
            for (const [, element] of Object.entries(this.$store.state.panelItems)) {
                if (element.url && val.indexOf(element.url) === 0) {
                    this.selectedItem = element;
                    return;
                }
            }
            // this.$store.state.panelItems.forEach((element) => {
            // });
        },
    },
    watch: {
        "$route.path": function (val) {
            this.checkSelected(val);
        },
    },
};
</script>

<style>
</style>

